import BaseService from "@/services/Base-service";

class PermissionService {
  get ControllerName() { return '/Permission/'; }

  getPermissionsList() {
    return BaseService.get(this.ControllerName + 'GetPermissions');
  }

  createPermission(model) {
    return BaseService.post(this.ControllerName + 'CreatePermission', model);
  }

  deletePermission(id) {
    return BaseService.post(this.ControllerName + 'DeletePermission/' + id);
  }

  editPermission(model) {
    return BaseService.post(this.ControllerName + 'EditPermission', model);
  }

  getPermission(id) {
    return BaseService.get(this.ControllerName + 'GetPermission/' + id);
  }
}
export default new PermissionService();